import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IAnnotation, ICustomMeasure } from '@se/models';
import { CaliperMeasuresComponent, ICustomMeasureButton } from '../caliper-measures/caliper-measures.component';
import { CustomMeasuresComponent } from '../custom-measures/custom-measures.component';
import { HeartRateUpdaterService } from '../../utils/ecg-measures.service';
import { IMeasuresViewModel } from '../../models/interfaces';
import { MatCard } from '@angular/material/card';
import { GlobalAnnotationsComponent } from '../annotations/global-annotations/global-annotations.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'caliper-and-measures',
    templateUrl: './caliper-and-measures.component.html',
    styleUrls: ['./caliper-and-measures.component.scss'],
    standalone: true,
    imports: [MatCard, CustomMeasuresComponent, GlobalAnnotationsComponent, NgIf, CaliperMeasuresComponent],
})
export class CaliperAndMeasuresComponent {
    // Data Members
    @ViewChild(CustomMeasuresComponent)
    customMeasuresComponent!: CustomMeasuresComponent;

    @Output()
    caliperMeasuresRemove: EventEmitter<IMeasuresViewModel> = new EventEmitter<IMeasuresViewModel>();
    @Output()
    caliperMeasuresRemoveAll: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    measureChange = new EventEmitter<ICustomMeasure>();
    @Output()
    closeCustomMeasuresClicked = new EventEmitter<any>();

    @Input()
    globalMeasures!: Array<IAnnotation>;
    @Input()
    customMeasures!: Array<ICustomMeasure>;
    @Input()
    caliperMeasures!: Array<IMeasuresViewModel>;
    @Input()
    customMeasureButtons!: ICustomMeasureButton[];
    @Input()
    showGlobalMeasures: boolean = false;
    @Input()
    showCustomMeasures: boolean = true;
    @Input()
    showCaliperMeasures: boolean = false;

    @Input()
    readOnly: boolean = false;
    @Input()
    isApprovedOrSigned: boolean | undefined;

    // Constructor

    constructor(private heartRateUpdaterService: HeartRateUpdaterService) {}

    // public functions

    onCloseCustomMeasures() {
        this.closeCustomMeasuresClicked.emit();
    }

    onCaliperMeasuresRemove(measures: IMeasuresViewModel) {
        this.caliperMeasuresRemove.emit(measures);
    }

    onCaliperMeasuresSet(customMeasureButton: ICustomMeasureButton) {
        let selectedCaliperMeasure = this.caliperMeasures.find((measure) => measure.selected);
        let selectedCustomMeasure = this.customMeasures.find(
            (measure) => measure.idEcgMeasure === customMeasureButton.tag,
        );
        if (!selectedCaliperMeasure || !selectedCustomMeasure) return;

        switch (customMeasureButton.valueToSet) {
            case 1:
                selectedCustomMeasure.value = Math.round(selectedCaliperMeasure.measures.deltaT);
                selectedCustomMeasure.isManualModified = true;
                break;
            case 2:
                selectedCustomMeasure.value =
                    Math.round((selectedCaliperMeasure.measures.deltaA + 0.00001) * 100) / 100;
                selectedCustomMeasure.isManualModified = true;
                break;
            case 3:
                selectedCustomMeasure.value = Math.round((selectedCaliperMeasure.measures.A1 + 0.00001) * 100) / 100;
                selectedCustomMeasure.isManualModified = true;
                break;
            case 4:
                selectedCustomMeasure.value = Math.round((selectedCaliperMeasure.measures.A2 + 0.00001) * 100) / 100;
                selectedCustomMeasure.isManualModified = true;
                break;
            case 5:
                selectedCustomMeasure.value = Math.round(selectedCaliperMeasure.measures.deltaT);
                selectedCustomMeasure.isManualModified = true;
                this.heartRateUpdaterService.heartRateChange.next(
                    Math.round(60 / (selectedCaliperMeasure.measures.deltaT / 1000)),
                );
                break;
        }

        this.measureChange.emit(selectedCustomMeasure);
        if (this.customMeasuresComponent) {
            this.customMeasuresComponent.updateMeasures();
        }
    }

    onManualMeasureChange(measure: ICustomMeasure) {
        if (measure.internalUid === 'RR_DURATION') {
            if (!!measure.value)
                this.heartRateUpdaterService.heartRateChange.next(Math.round(60 / (measure.value / 1000)));
        }

        this.measureChange.emit(measure);
    }

    onCaliperMeasuresRemoveAll() {
        this.caliperMeasuresRemoveAll.emit();
    }
}
